import React, { FunctionComponent } from 'react'
import { useTranslation } from 'react-i18next'

import Button from '../../../../App/Components/Button/Button'

import { IProps } from './IProps'

export const SubmitError: FunctionComponent<IProps> = ({ setSubmitState }) => {
    const { t } = useTranslation()
    return (
        <>
            <div className={'status-message warning'}>
                <p>
                    {t(
                        'An error occured creating your account. Please try again or contact support.'
                    )}
                </p>
            </div>
            <Button type={'button'} onClick={() => setSubmitState('idle')}>
                {t('Try again')}
            </Button>
        </>
    )
}
